import { useEffect } from 'react';
import { emitPreviewRequest } from '@/events/previewBus';

interface ShortcutHandlers {
  onEscape?: () => void;
  onDelete?: () => void;
  onSelectAll?: () => void;
}

export function useKeyboardShortcuts({ onEscape, onDelete, onSelectAll }: ShortcutHandlers) {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      const tag = (e.target as HTMLElement)?.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || (e.target as HTMLElement)?.isContentEditable) {
        return;
      }

      if (e.key === 'Escape') {
        e.preventDefault();
        onEscape?.();
        emitPreviewRequest({ type: 'empty', content: '' });
      }

      if (e.key === 'Delete' || e.key === 'Backspace') {
        e.preventDefault();
        onDelete?.();
      }

      if ((e.ctrlKey || e.metaKey) && e.key === 'a') {
        e.preventDefault();
        onSelectAll?.();
      }
    };

    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onEscape, onDelete, onSelectAll]);
}
